export default {
  name: 'MicrosoftMarketplaceError',

  computed: {
    error_message() {
      const message = this.$route.query.error;
      return typeof message === 'string' ? message : 'Marketplace activation could not be completed.';
    },
  },

  methods: {
    go_to_login() {
      this.$router.push({ name: 'Login' });
    },
  },
};
